import React, { Suspense, useEffect, useState } from "react";
import "./ResetPassword.css";

import Header from "../../DefaultLayout/Header";
import Footer from "../../DefaultLayout/Footer";
import Loading from "../../components/Loading";
import {

  Link,

} from "react-router-dom";
import { Button, Form, FormGroup,  Input,  } from "reactstrap";

import {   connect } from "react-redux";
import { useHistory, useLocation } from "react-router";
import {
  matchPassword,
  checkEmptyValidation,
} from "./../../Helpers/Validation";
import { changedPassword } from './../../actions/forgotPasswordAction';
import { toast } from "react-toastify";
import DashboardNavbar from "../../DefaultLayout/DashboardNavbar";

const ResetPassword = (props) => {
  const { frontLabelsName } = props.label;
  const history = useHistory();



  const [newPassword, setNewPassword] = useState("");
  const [conifrmPassword, setConifrmPassword] = useState("");
  const [newPasswordError, setnewPasswordError] = useState("");
  const [conifrmPasswordError, setConifrmPasswordError] = useState("");
  const [comparePassWord, setComparePassWord] = useState("");

  const location = useLocation();
  // const { detail } = location.state;

  // let gettingEmail = detail

  useEffect(() => {
    if (location?.state?.detail != undefined && location?.state?.checkVerify === undefined) {
      history.push("/forget-password")
    }
    if (location?.state?.detail === undefined) {
      history.push("/verify-otp")
    }
  }, [])

  const onSubmit = (e) => {
    e.preventDefault();

    let validationFlag = true;

    let errPas = "";
    let errPas2 = "";
    let errPas3 = "";
    errPas = checkEmptyValidation(newPassword, "lbl_new_password");
    errPas2 = checkEmptyValidation(conifrmPassword, "lbl_confirm_password");
    errPas3 = matchPassword(newPassword, conifrmPassword);
    if (errPas || errPas2 || errPas3) {
      validationFlag = false;
      setnewPasswordError(frontLabelsName
        ? frontLabelsName.filter((e) => e.key == errPas)
          .length > 0
          ? frontLabelsName.filter((e) => e.key == errPas)[0][
          "value"
          ] || errPas
          : errPas
        : errPas);
      setConifrmPasswordError(frontLabelsName
        ? frontLabelsName.filter((e) => e.key == errPas2)
          .length > 0
          ? frontLabelsName.filter((e) => e.key == errPas2)[0][
          "value"
          ] || errPas2
          : errPas2
        : errPas2);
      setComparePassWord(frontLabelsName
        ? frontLabelsName.filter((e) => e.key == errPas3)
          .length > 0
          ? frontLabelsName.filter((e) => e.key == errPas3)[0][
          "value"
          ] || errPas3
          : errPas3
        : errPas3);
    } else {
      validationFlag = true;
      setnewPasswordError(errPas);
      setConifrmPasswordError(errPas2);
      setComparePassWord(errPas3);
    }

    let newObj = {
      email: location.state.detail,
      password: conifrmPassword,
    };
    if (validationFlag) {
      props.changedPassword(newObj).then((res) => {
        toast.success(frontLabelsName
          ? frontLabelsName.filter((e) => e.key == res.data.message)
            .length > 0
            ? frontLabelsName.filter((e) => e.key == res.data.message)[0][
            "value"
            ] || res.data.message
            : res.data.message
          : res.data.message);
        history.push("/login");
      }).catch((err) => {
        toast.error(frontLabelsName
          ? frontLabelsName.filter((e) => e.key == err.response.data.message)
            .length > 0
            ? frontLabelsName.filter((e) => e.key == err.response.data.message)[0][
            "value"
            ] || err.response.data.message
            : err.response.data.message
          : err.response.data.message);
      })
    }
  };
  if (location?.state?.detail != undefined && location?.state?.checkVerify === undefined) {
    history.push("/verify-otp");
  }

  return (
    <React.Fragment>
      <Suspense fallback={<Loading />}>
        <Header />

        {/* <NavbarSection /> */}
        <DashboardNavbar/>
      </Suspense>
      <div className="main-login">
        <div className="reset-box">
          <Form>
            <div className="text-center">
              <h2 className="fr-box-set">
                {frontLabelsName
                  ? frontLabelsName.filter(
                    (e) => e.key == "lbl_reset_password"
                  ).length > 0
                    ? frontLabelsName.filter(
                      (e) => e.key == "lbl_reset_password"
                    )[0]["value"] || "lbl_reset_password"
                    : "lbl_reset_password"
                  : "lbl_reset_password"}
              </h2>
              <p className="fr-set-p">
                {frontLabelsName
                  ? frontLabelsName.filter(
                    (e) => e.key == "lbl_please_choose_new_pwd"
                  ).length > 0
                    ? frontLabelsName.filter(
                      (e) => e.key == "lbl_please_choose_new_pwd"
                    )[0]["value"] || "lbl_please_choose_new_pwd"
                    : "lbl_please_choose_new_pwd"
                  : "lbl_please_choose_new_pwd"}
              </p>
            </div>

            <div className="set-pdd">
              <div className="set-width-ddddd">
                <FormGroup className="set-bg-feild mb-4">
                  <Input
                    type="password"
                    name="newPassword"
                    placeholder={frontLabelsName
                      ? frontLabelsName.filter(
                        (e) => e.key == "lbl_new_password"
                      ).length > 0
                        ? frontLabelsName.filter(
                          (e) => e.key == "lbl_new_password"
                        )[0]["value"] || "lbl_new_password"
                        : "lbl_new_password"
                      : "lbl_new_password"}
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                  />
                  {newPasswordError && (
                    <span className="invalid_span">{newPasswordError}</span>
                  )}
                </FormGroup>
                <FormGroup className="set-bg-feild mb-4">
                  <Input
                    type="password"
                    name="conifrmPassword"
                    value={conifrmPassword}
                    placeholder={frontLabelsName
                      ? frontLabelsName.filter(
                        (e) => e.key == "lbl_confirm_new_password"
                      ).length > 0
                        ? frontLabelsName.filter(
                          (e) => e.key == "lbl_confirm_new_password"
                        )[0]["value"] || "lbl_confirm_new_password"
                        : "lbl_confirm_new_password"
                      : "lbl_confirm_new_password"}
                    onChange={(e) => setConifrmPassword(e.target.value)}
                  />
                  {conifrmPasswordError && (
                    <span className="invalid_span">{conifrmPasswordError}</span>
                  )}
                  {comparePassWord && (
                    <span className="invalid_span">{comparePassWord}</span>
                  )}
                </FormGroup>

                <div className="button-set mb-3">
                  <Button type="button" onClick={(e) => onSubmit(e)}>
                    {frontLabelsName
                      ? frontLabelsName.filter(
                        (e) => e.key == "lbl_submit"
                      ).length > 0
                        ? frontLabelsName.filter(
                          (e) => e.key == "lbl_submit"
                        )[0]["value"] || "lbl_submit"
                        : "lbl_submit"
                      : "lbl_submit"}
                  </Button>
                </div>
              </div>

              <div className="back-top-login text-center">
                <Link to="/login">
                  {frontLabelsName
                    ? frontLabelsName.filter(
                      (e) => e.key == "lbl_back_to_login"
                    ).length > 0
                      ? frontLabelsName.filter(
                        (e) => e.key == "lbl_back_to_login"
                      )[0]["value"] || "lbl_back_to_login"
                      : "lbl_back_to_login"
                    : "lbl_back_to_login"}
                </Link>
              </div>
            </div>
          </Form>
        </div>
      </div>
      <Suspense fallback={<Loading />}>
        <Footer />
      </Suspense>
    </React.Fragment>
  );
};
const mapStateToProps = (state) => ({
  label: state.language
})

export default connect(mapStateToProps, { changedPassword })(ResetPassword);
